var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5212 0H13.2525L16.5411 5.79412L10.0961 17.1102H3.36365L0 11.2434L6.5212 0ZM6.79655 1.46253L1.12201 11.2463L3.64382 15.6446L9.25458 5.79326L6.79655 1.46253ZM10.0961 6.2797L4.48129 16.1382H9.53111L15.146 6.2797H10.0961ZM15.1474 5.30768H10.0966L7.63579 0.97198H12.6866L15.1474 5.30768Z",
    fill: "#7FEE64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 11.317L28.6342 17.1466L21.9722 17.0974L15.3945 5.85781L18.7608 0.0273438L25.5235 0.0477399L32 11.317ZM30.5956 10.8242L24.9599 1.01803L19.89 1.00273L25.6162 10.7875L30.5956 10.8242ZM24.7742 11.2731L19.0438 1.48123L16.5188 5.8545L22.2492 15.6464L24.7742 11.2731ZM23.0903 16.1335L25.6156 11.7595L30.6008 11.7962L28.0755 16.1702L23.0903 16.1335Z",
    fill: "#7FEE64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo23);
export default __webpack_public_path__ + "static/media/logo23.f6ef3239959d5231c5c41886f0aec1dd.svg";
export { ForwardRef as ReactComponent };